export default {
  cancelOrderMap: {
    0: "Ich will es nicht.",
    1: "Habe das Produkt verlegt",
    2: "Doppelte Bestellung",
    3: "Empfang fehlgeschlagen",
    4: "Andere Gründe",
  },
  "获取验证码": "Erhält Zahl",
  "请输入验证码": "Bitte geben Sie die Zahl ein",
  "发送": "Senden",
  "验证码": "Code",
  "已发送，请注意查收": "Gesendet, bitte beachten Sie die Abholung",
  "加值": "Wert hinzufügen",
  "银行卡": "Bankkarte",
  "平台人工发起退款": "Plattforminitiierte Rückerstattung",
  "联系商家": "Kontaktieren Sie den Händler",
  "提领": "Abheben",
  "电商批发商场": "E-Commerce-Großhandelsmarkt",
  "请输入完整的支付密码!" : "Bitte geben Sie das vollständige Zahlungspasswort ein!",
  "用户未发表评论": "Benutzer hat nicht kommentiert",
  "订单": "Befehl",
  "下单成功，等待付款": "Bestellung erfolgreich aufgegeben, wartet auf Zahlung",
  "下单成功，付款成功": "Bestellung erfolgreich aufgegeben, Zahlung erfolgreich",
  "已发货，正在运输中": "Versendet, im Transport",
  "订单已取消，原因:手动发起取消订单": "Die Bestellung wurde storniert. Grund: Bestellung manuell stornieren.",
  "订单已取消，原因:超时自动取消订单": "Bestellung wurde storniert. Grund: Die Bestellung wird bei Zeitüberschreitung automatisch storniert.",
  "商家已确认，已进入备货状态": "Der Händler wurde bestätigt und ist in den Bestandsstatus eingetreten.",
  "长时间未付款，系统自动取消订单": "Bei Nichtzahlung über einen längeren Zeitraum wird die Bestellung automatisch storniert.",
  "系统发货成功": "Systembereitstellung erfolgreich",
  "订单已签收": "Bestellung erhalten",
  "发起退款申请": "Starten Sie eine Rückerstattungsanfrage",
  "退款成功": "Rückerstattung erfolgreich",
  "退款失败": "Rückerstattung fehlgeschlagen",
  "订单退款成功": "Rückerstattung der Bestellung erfolgreich",
  "订单退款失败": "Rückerstattung der Bestellung fehlgeschlagen",
  "系统默认好评": "Das System verwendet standardmäßig positive Bewertungen",
  "请输入关键字搜索": "Bitte geben Sie ein Stichwort zur Suche ein",
  "猜你喜欢": "Denke es gefällt dir",
  "订单已完成": "Die Bestellung ist abgeschlossen",
  "热销推荐": "Heiße Verkaufsempfehlung",
  "头像选择": "Avatar-Auswahl",
  "修改头像": "Ändern Sie Ihren Avatar",
  subOrder: "Bestellung abschicken",
  "mailboxCheck": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  "switchLang": "Bitte wechseln Sie zur Anzeige in eine andere Sprache",
  "myCart": "Mein Einkaufswagen",
  "notQua": "Die Qualifikationsbedingungen sind nicht erfüllt.",
  "noSmaller": "Die aufgebrachte Menge darf nicht kleiner sein als",
  "nomax": "Die maximale Antragsmenge darf nicht überschritten werden",
  "evaluationUploading": "Sie müssen noch Bilder hochladen. Bitte versuchen Sie es später erneut",
  "evaluateInput": "Rückblick mit Bildern",
  "moneyOrderStatus": "Bestellstatus",
  "coinBlock": "Währungsabkommen",
  "dealing": "In Bearbeitung",
  "dealSuccess": "Erfolgreich",
  "dealFail": "Scheitern",
  "payCertificate": "Zahlungszertifikat",
  "handleFee": "Servicegebühr",
  "highOpinion": "Gute Rückmeldungen",
  "mediumOpinion": "Mittlere Bewertung",
  "lowOpinion": "Schlechte Bewertungen",
  "hasImage": "Mit Bildern",
  "rechargeMethod": "Auflademodus",
  "scanAndDown": "QR-Code scannen APP herunterladen",
  "receivedAddress": "Empfangsadresse",
  "ActualLedger": "Tatsächliche Quittung",
  "view": "Sicht",
  "withdrawNum": "Bargeldabhebungsmenge",
  "rechargeNum": "Menge aufladen",
  "date": "Datum",
  "walletHistory": "Brieftaschenverlauf",
  "accountBalance": "Kontostand",
  "accountReview": "Kontoübersicht",
  "rated": "Überprüft",
  "receiver": "Empfänger",
  "orderStatus": "Status",
  "orderTime": "Zeit",
  "tax": "Besteuerung",
  "discount": "Rabatt",
  "productInfo": "Produktinformation",
  "paramError": "Parameterfehler",
  "orderInfo": "Bestellinformationen",
  "rebuy": "Noch eine Bestellung",
  "pleaseCorrectAddress": "Bitte geben Sie die korrekte Bargeldabhebungsadresse ein",
  "pleaseInputCorrectNumber": "Bitte geben Sie eine Zahl größer als 0 ein",
  "vcodePass": "Überprüfung bestanden!",
  "vcodeFail": "Authentifizierung fehlgeschlagen. Bitte erneut versuchen",
  "uploading": "Hochladen...",
  "uploadSuccess": "Hochgeladen erfolgreich",
  "uploadError": "Upload fehlgeschlagen. Bitte versuche es erneut",
  "registerSuccess": "Registrierung erfolgreich",
  "pleaseSetMobileNumber": "Bitte geben Sie die Telefonnummer ein",
  "unSelectedProduct": "Sie haben kein Produkt ausgewählt",
  "loginSuccess": "Anmeldung erfolgreich",
  "pleaseSetAreaCode": "Geben Sie den Ländernamen und die Ortsvorwahl ein, um zu suchen",
  "login": "Anmeldung",
  "register": "Anmeldung",
  "logout": "Ausfahrt",
  "noData": "Keine Daten gefunden",
  "search": "Suchen",
  "historySearch": "Historische Suche",
  "empty": "Leer",
  "home": "Startseite",
  "favorableRate": "Rate guter Bewertungen",
  "classification": "Kategorie",
  "searchTips": "Quellensuche/Produkt/Lieferant/Bestellung",
  "dailyNewArrival": "Täglich neue Produkte aufgelistet",
  "more": "Mehr",
  "recommend": "Empfehlung",
  "recommendedProducts": "Empfohlene Produkte",
  "recommendedStore": "Empfehlenswerte Geschäfte",
  "buyNow": "Jetzt kaufen",
  "addCart": "In den Warenkorb legen",
  "complex": "Integriert",
  "price": "Preis",
  "retailPrice": "Endverbraucherpreis",
  "originPrice": "Original Preis",
  "service": "Kundendienst",
  "collect": "Favoriten",
  "sold": "Verkaufsvolumen",
  "pageviews": "Umfang des Surfens",
  "quantity": "Menge",
  "freight": "Ladung",
  "shipping": "Versand",
  "ship": "Boot",
  "buyTips": "Versand innerhalb von 24 Stunden nach Auftragserteilung. Die folgenden Bestellungen unterliegen der logistischen Kontrolle und werden möglicherweise verspätet versendet. Bitte beachten Sie die Logistikinformationen oder wenden Sie sich an den Kundendienst.",
  "totalPrice": "Gesamtpreis",
  "addCartMessage": "Erfolgreich zum Warenkorb hinzugefügt",
  "addCartMessageFaild": "Das Produkt ist bereits im Warenkorb vorhanden.",
  "myAccount": "Mein Konto",
  "buyHistory": "Aufzeichnungen kaufen",
  "wishlist": "Lieblingsprodukte",
  "trackOrder": "Befehl",
  "account": "Konto:",
  "sellerZone": "Händlerbereich",
  "beSeller": "Kaufmann werden",
  "sellerPanelLogin": "Händler-Login",
  "footTip": "© Urheberrecht {name} Ltd 2024",
  "footTips": "{name} Limited ist von der Financial Conduct Authority als Kreditvermittler (713206) autorisiert und reguliert und handelt ausschließlich mit dem Kreditgeber Home Retail Group CardServices Limited als {name} Financial Services. {name} Financial Services ist von der Financial Conduct Authority zur Bereitstellung von Krediten autorisiert und reguliert (716148). Home Retail GroupCard Services Limited ist im Vereinigten Königreich (04007072) in Avebury, 489-499 Avebury Boulevard, Milton Keynes, Vereinigtes Königreich, registriert. MK9 2NW.",
  "item": "Artikel",
  "checkout": "Eine Bestellung aufgeben",
  "productDescription": "Produktbeschreibung",
  "userEvaluation": "Benutzerbewertungen",
  "AllProducts": "Alle Produkte",
  "followers": "Folgen",
  "sales": "Verkaufsvolumen",
  "visitStore": "Besuchen Sie den Laden",
  "authentic": "100% echt",
  "dayReturns7": "7 Tage Rückgaberecht",
  "shippingDiscounts": "Frachtrabatt",
  "safePayment": "Sichere Bezahlung",
  "followed": "Gefolgt",
  "dashboard": "Instrumententafel",
  "myOrder": "Meine Bestellung",
  "setUp": "Aufstellen",
  "successTips": "Erfolgreich",
  "copySuccess": "Replikation erfolgreich",
  "balance": "Guthaben (USDT)",
  "sort": "Typ",
  "commodity": "Produkt",
  "browse": "Verkaufsvolumen",
  "recharge": "Aufladen",
  "commodityCollection": "Produktsammlung",
  "withdraw": "Bargeldabhebung",
  "defaultAddress": "Standardadresse",
  "addNewAddress": "Neue Adresse hinzufügen",
  "withdrawRecord": "Bargeldabhebungsaufzeichnung",
  "serialNumber": "Best.-Nr.",
  "time": "Zeit",
  "amount": "Menge",
  "processing": "In Bearbeitung",
  "fail": "Scheitern",
  "blockchainNetwork": "Blockchain-Netzwerk",
  "records": "Aufzeichnen",
  "withdrawAddress": "Adresse für Bargeldabhebungen",
  "withdrawInputTips": "Bitte geben Sie die Auszahlungsadresse ein",
  "copy": "Reproduzieren",
  "enterTips": "Bitte eingeben",
  "actualAccount": "Tatsächliches Konto",
  "handlingFee": "Servicegebühr",
  "confirm": "Empfang bestätigen",
  "previous": "Vorheriger Schritt",
  "pleaseEnterAddress": "Bitte geben Sie die Adresse ein",
  "pleaseEnterQuantity": "Bitte Menge eingeben",
  "withdrawSuccess": "Bestellungen erfolgreich übermittelt",
  "saveQr": "QR-Code speichern",
  "pleaseEnterAmount": "Bitte geben Sie den Aufladebetrag ein",
  "expectedArrival": "Erwartete Ankunft",
  "currentRate": "Aktueller Wechselkurs",
  "uploadTips": "Zahlungsnachweis (Screenshot der Zahlungsdetails hochladen)",
  "clickUpload": "Zum Hochladen klicken",
  "uploadPhoto": "Bitte laden Sie Fotos hoch",
  "rechargeSuccessful": "Aufladen erfolgreich",
  "rechargeTips": "Aufladeaufforderung: „Bitte geben Sie den tatsächlichen Überweisungsbetrag wahrheitsgemäß ein. Andernfalls kann das System die Genehmigung nicht bestehen und den Aufladevorgang beeinträchtigen.",
  "rechargeRecord": "Rekord aufladen",
  "all": "Alle",
  "pending": "Bezahlt werden",
  "cancelled": "Abgesagt",
  "delivered": "Verschifft werden",
  "confirmed": "Bestätigt",
  "receipt": "Empfangen werden",
  "harvested": "Erhalten",
  "comment": "Überprüft werden",
  "refund": "Rückerstattung/After-Sales",
  "cancelOrder": "Bestellung stornieren",
  "cancelReason": "Grund der Stornierung",
  "cancelOrderTitle": "Bitte wählen Sie einen Grund für die Auftragsstornierung aus",
  "returnOrderTitle": "Bitte wählen Sie den Rücksendegrund aus",
  "refundInstructions": "Anweisungen zur Rückerstattung",
  "returnDetailTips": "Bitte geben Sie eine Bewertung zum Produkt ab",
  "cancel": "Bestellung stornieren",
  "cancelOrder1": "Produkt nicht erhalten",
  "cancelOrder2": "Mag es nicht, will es nicht",
  "cancelOrder3": "Der Verkäufer hat die falsche Ware geliefert",
  "cancelOrder4": "Gefälschte Marke",
  "cancelOrder5": "Weniger Sendung, verpasste Sendung",
  "cancelOrder6": "Produkt beschädigt erhalten",
  "cancelOrder7": "Es liegt ein Qualitätsproblem vor",
  "cancelOrder8": "Verhandeln Sie die Rückerstattung mit dem Händler",
  "cancelOrder9": "Andere Gründe",
  "cancelOrderSuccess": "Bestellung erfolgreich storniert",
  "returnOrderSuccess": "Erfolgreich einreichen",
  "orderName": "Name",
  "orderEmail": "Email",
  "orderAddress": "Adresse",
  "orderNation": "Land",
  "orderState": "Status",
  "orderCity": "Stadt",
  "orderPostCode": "Postleitzahl",
  "orderAmount": "Menge",
  "orderPrefix": "Gesamtbestellung",
  "orderFee": "Steuern",
  "orderSpecification": "Spezifikation",
  "orderCommodity": "Produkt",
  "orderQuantity": "Menge",
  "orderUnitprice": "Einzelpreis",
  "orderFreight": "Ladung",
  "orderTax": "Steuer",
  "orderTotal": "Gesamt",
  "PaymentOrder": "Zahlungsauftrag",
  "Evaluate": "Rezension",
  "CancelOrder": "Bestellung stornieren",
  "RemindShip": "Erinnern Sie sich an den Versand",
  "Refund": "Erstattung",
  "Submitareview": "Bewertungen abgeben",
  "Information": "Information",
  "wrongPassword": "Passwortfehler mehr als 3 Mal. Bitte versuchen Sie es morgen erneut.",
  "Operate": "Betrieb",
  "Item": "Artikel)",
  "From": "Aus",
  "hint": "Tipps",
  "CheckDetails": "Einzelheiten anzeigen",
  "Payment": "Zahlung",
  "Cancel": "Stornieren",
  "refundSuccessfully": "Rückerstattung erfolgreich",
  "pendingPayment": "Bezahlt werden",
  "pay": "Zahlung",
  "LoginPassword": "Passwort",
  "sure": "Natürlich",
  "shippingAddress": "Empfangsadresse",
  "pleaseAddShippingAddress": "Bitte fügen Sie zuerst eine Lieferadresse hinzu",
  "transactionPassword": "Transaktions Passwort",
  "markDefaultAddress": "Als Standardlieferadresse markieren",
  "edit": "Bearbeitet von",
  "delete": "Löschen",
  "Opt": "Wählen",
  "piece": "Stck",
  "orderDetails": "Bestelldetails",
  "shopCollection": "Fügen Sie den Shop zu den Favoriten hinzu",
  "addAddress": "Neue Adresse hinzufügen",
  "signUp": "Anmeldung",
  "loginTips": "Sie haben bereits ein Konto?",
  "loginIn": "Anmeldung",
  "mobile": "Telefon-Nr",
  "modifyAddress": "Adresse bearbeiten",
  "desc": "Als Standardadresse festlegen",
  "keep": "Pflegen",
  "onlineService": "Online Dienste",
  "send": "Schicken",
  "EsShop": "Online-Shop",
  "desc3": "Geben Sie das Transaktionspasswort ein",
  "desc4": "Geben Sie Ihr Transaktionspasswort ein",
  "desc6": "Geben Sie Ihr Transaktionspasswort erneut ein",
  "setUpPayPaw": "Transaktionskennwort festlegen",
  "setSuccess": "Einrichtung erfolgreich",
  '购物车还没有商品': 'Der Einkaufswagen hat noch keine Waren',
  '去购物': 'Einkaufen gehen',
  "confirmPayPaw": "Bestätigen Sie das Transaktionspasswort",
  "paymentSuccessful": "Zahlung erfolgreich abgeschlossen",
  "paymentPending": "Zahlung ausstehend",
  "paymentPendingDesc": "Ihre Zahlung wird bearbeitet. Bitte überprüfen Sie später den Status Ihrer Bestellung",
  "desc5": "Falsche Lieferadresse? Kontakt",
  "customeService": "Online-Kundendienst",
  "BackHome": "Zurück zur Startseite",
  "Checkorder": "Bestellung ansehen",
  "ForgotPassword": "Passwort vergessen?",
  "signIn": "Anmeldung",
  "noAccount": "Keine Kontonummer?",
  "pleaseEnterAccount": "Bitte Kontonummer eingeben",
  "pleaseEnterPassword": "Bitte Passwort eingeben",
  "password": "Passwort",
  "mobilePhone": "Telefonnummer",
  "pleaseEnterPhoneNumer": "Bitte geben Sie die Telefonnummer ein",
  "setPassword": "Passwort festlegen",
  "noDataFound": "Keine Daten gefunden",
  "searchCountry": "Geben Sie den Ländernamen und die Ortsvorwahl ein, um zu suchen",
  "pleaseEnterEmail": "Bitte stellen Sie das Postfach ein",
  "invitationCode": "Einladungscode",
  "plaeseEnterInvitaionCode": "Bitte legen Sie den Einladungscode fest",
  "pleaseSetLoginPassword": "Bitte legen Sie das Login-Passwort fest",
  "selectDeliveryAddress": "Lieferadresse auswählen",
  "totalOf": "Gesamt",
  "items": "Artikel",
  "orderSummary": "Bestellübersicht",
  "paymentMethod": "Bezahlverfahren",
  "Balance": "Gleichgewicht",
  "payPal": "PayPal",
  "notOpen": "Diese Zahlungsmethode ist für Ihre Region noch nicht verfügbar",
  "mastercard": "MasterCard",
  "additional": "Extra",
  "handlingfee": "Servicegebühr erforderlich",
  "goodsNumber": "Menge der Produkte",
  "deliveryFee": "Fracht",
  "totalNum": "Gesamt",
  "new": "Neu",
  "oldPassword": "Altes Kennwort",
  "pleaseEnterOldPassword": "Bitte geben Sie das alte Passwort ein",
  "newPassword": "Neues Kennwort",
  "plaseeEnterNewPassword": "Bitte geben Sie das neue Passwort ein",
  "confirmPassword": "Bestätige das Passwort",
  "plaseeENterConfirmPassword": "Bitte geben Sie das Bestätigungspasswort ein",
  "twoPawword": "Zwei Passwörter sind nicht gleich",
  "rechargeAddress": "Adresse aufladen",
  "plaseEnterRechargeAddress": "Bitte geben Sie die Aufladeadresse ein",
  "userCenter": "Persönliches Zentrum",
  "merchantSettled": "Händlereintrag",
  "upNew": "Neues Produkt aufgeführt",
  "balanceNot": "Das Guthaben reicht nicht. Bitte aufladen.",
  "NoProductSelected": "Produkt noch nicht ausgewählt",
  "ShippingAddressNotSet": "Lieferadresse nicht festgelegt",
  "consigneeName": "Name des Empfängers",
  "email": "Email:",
  "areaCode": "Internationale Vorwahl",
  "phoneNumber": "Telefonnummer",
  "nation": "Land",
  "state": "Provinz/Staat/Staat",
  "city": "Stadt",
  "postCode": "Postleitzahl",
  "address": "Detaillierte Adresse",
  "addAddressOrModifyAddress": "Neue Adresse hinzufügen/Adresse ändern",
  "setAsTheDefaultAddress": "Als Standardadresse festlegen",
  "proceed": "Weitermachen",
  "btnSure": "Bestätigen",
  "pleaseInput": "Bitte eingeben",
  "allProduct": "Alle Produkte",
  "myCommodityCollection": "Lieblingsprodukte",
  "myFollowedShops": "Folgen Sie dem Laden",
  "mySold": "Verkauft",
  "myPageviews": "Umfang des Surfens",
  "myPraiseRate": "Rate guter Bewertungen",
  "myUnfollow": "Entfolgen",
  "inputNum": "Zahlen",
  "inpuEmailErro": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  "goodsShip": "Sendung",
  "goodsShipTips": "Die Produkte werden innerhalb von 24 Stunden nach der Bestellung versendet. Wenn für die folgende Bestellung eine Logistikkontrolle besteht, kann sich die Bestellung verzögern. Bitte beachten Sie die Logistikinformationen der Bestellung oder wenden Sie sich an den Kundenservice.",
  "goodsFreight": "Fracht",
  "goodsFreeShipping": "Kostenlos",
  "goodsFreightTips1": "1. Zusammensetzung der grenzüberschreitenden Produktfracht: Fracht = Versandgebühr + Fernfracht + Zustellgebühr",
  "goodsFreightTips2": "2. Bei Nichteinhaltung der Versandbedingungen wird die Fracht nach den tatsächlichen Bedingungen berechnet.",
  "goodsFreightTips3": "3. Das Recht der endgültigen Auslegung liegt bei der Plattform.",
  "pleaseValidPostCode": "Bitte geben Sie mehr als 4 Ziffern ein",
  "pleaseValidEmail": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  "pleaseValidPhone": "Bitte geben Sie die richtige Telefonnummer ein",
  "productAvailable": "Dieses Produkt wurde entfernt",
  "validatorMaxNumber": "Der Betrag überschreitet das Limit",
  "validatorRequire": "Erforderliche Elemente dürfen nicht null sein",
  "validatorPhone": "Bitte geben Sie die richtige Telefonnummer ein",
  "validatorEmail": "Bitte geben Sie das richtige E-Mail-Format ein",
  "validatorPassword": "Das Passwort besteht aus 6-12 Ziffern oder Buchstaben(enthält Sonderzeichen)",
  "validatorSixNumber": "Bitte geben Sie 6 reine Ziffern ein",
  "validatorFourMoreNumber": "Bitte geben Sie eine Kombination aus 4-32 Ziffern oder Buchstaben ein",
  "validatorIpRule": "Falsches IP-Format",
  "validatorChineseAndEnglish": "Nur Chinesisch und Englisch, Eingabebereich: 8–64 Zeichen",
  "collectionSuccess": "Zu Favoriten hinzufügen erfolgreich",
  "followedSuccess": "Folgen erfolgreich",
  "cancelSuccess": "Abbruch erfolgreich",
  "evaluateOrder": "Rückblick mit Bildern",
  "evaluateOrderPlaceholder": "Bitte überprüfen Sie die Produkte",
  "operationSuccess": "Vorgang erfolgreich",
  "confirmReceiveGoods": "Bestätigen Sie den Erhalt des Produkts oder nicht",
  "evaluateOrderSuccess": "Überprüfung erfolgreich",
  "yesterday": "Gestern",
  "notLogin": "Sie haben sich noch nicht eingeloggt.",
  "delAllHistoryRecord": "Möchten Sie wirklich alle Verlaufsdatensätze löschen?",
  "or": "Oder",
  "tipsRemindsText": "Der Händler erhält eine Mahnung, nachdem der Versand gemahnt wurde",
  "tipsRemindsCount": "Es kann nur einmal gemahnt werden.",
  "tipsRemindsMerchant": "Händler erinnern",
  "tipsRemindsSuccess": "Erinnerung erfolgreich",
  "noCartTips": "Deine Einkaufstasche ist leer. Beginn mit dem Einkauf.",
  "defaultRate": "Das System verwendet standardmäßig positive Bewertungen",
  "prevPage": "Vorherige Seite",
  "nextPage": "Nächste Seite",
  "returnApply": "Erstattungsantrag",
  "returnReason": "Grund der Rückerstattung",
  "returnAmount": "Rückgabebetrag",
  "returnRemark": "Rücksendeanleitung",
  order: {
    cancel: "Bestellung stornieren",
    payment: "Zahlen Sie jetzt",
    remind: "Erinnern Sie sich an den Versand",
    return: "Antrag auf Produktrückerstattung",
    evaluate: "Jetzt überprüfen",
    logistics: "Logistik ansehen",
    noRefund: "Nicht erstattet",
    refunding: "Rückerstattung läuft",
    refundSuccess: "Rückerstattung erfolgreich",
    refundFail: "Rückerstattung fehlgeschlagen",
    confirm: "Empfang bestätigen",
  },
  "remindTitle": "Erinnern Sie sich an den Versand",
  "remindContent": "Nachdem der Versand gemahnt wurde, erhält der Händler die Mahnung. Es kann nur einmal gemahnt werden.",
  "remindSuccess": "Erinnerung erfolgreich",
  "remindRepeat": "Diese Bestellung wurde erinnert.",
  "noComments": "Derzeit keine Bewertung",
  "storeSeach": "Produkt in diesem Shop suchen",
  "storeSeachTips1": "für dich gefunden",
  "storeSeachTips2": "Ähnliche Geschäfte gefunden",
  "storeSeachTips3": "Heim",
  "creditTit": "Kreditdienstleistungen",
  "getCoupons": "Holen Sie sich weitere Gutscheine",
  "yourEmail": "Ihre E-Mail-Adresse",
  "subscription": "Abonnements",
  "paymethods": "Bezahlverfahren",
  "footdec": "Die Benutzer der globalen Website von {name} kommen aus {num} Ländern auf der ganzen Welt und verwenden {coin} für die Abrechnung. {coin} ist eine grenzenlose Transaktion, die sofortige, kostengünstige Transaktionen auf der ganzen Welt ohne Wartezeiten und internationale Gebühren ermöglicht.",
  "custService": "Kundendienst",
  "helpLine": "Online-Kundendienst",
  "contactUs": "Kontaktiere uns",
  "partner": "Genossenschaftliche Lieferanten",
  "buyRules": "Käuferregeln",
  "sellerRules": "Richtlinie des Verkäufers",
  "returnsAndEx": "Rückgabe und Umtausch",
  "servicePolicy": "Servicepolitik",
  "returnPolicy": "Rücknahmegarantie",
  "user_Center": "Benutzerzentrum",
  "userReg": "Benutzer Registration",
  "orderTrack": "Bestellanfrage",
  "purchageHistory": "Kaufhistorie",
  "myPurse": "Mein Geldbeutel",
  "aboutUs": "Über uns",
  "Recruitment": "Warten Sie auf talentierte Personen",
  "news": "Nachrichteninformationen",
  "stateMent": "Erklärung zur modernen Sklaverei",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "ok",
  "metaMask": "MetaMask",
  "homeBannertips1": "Kaufmann werden",
  "homeBannertips2": "Gesamtprovision",
  "homeBannertips3": "max.",
  "homeBannerbtn": "Jetzt beitreten",
  "homeDownloadtips1": "Grenzüberschreitendes E-Commerce-Großhandelszentrum",
  "homeDownloadtips2": "Marken-Sonderangebot",
  "homeDownloadtips3": "Non-Stop-Rabatt",
  "homeDownloadtips4": "Android-Download",
  "homeDownloadtips5": "Apple-Download",
  "homeDownloadtips6": "Scannen Sie den QR-Code, um die APP herunterzuladen",
  "homeIconTips1": "100% echt",
  "homeIconTips2": "7 Tage Rückgaberecht",
  "homeIconTips3": "Frachtrabatt",
  "homeIconTips4": "Sichere Bezahlung",
  "headerSearchTips": "Bitte geben Sie ein Stichwort zur Suche ein",
  "collAccount": "Art der Ausleihe",
  "mine": "Mine.",
  "creditText1": "Startkredite lösen das Problem der Kreditaufnahme",
  "creditText2": "Erbringung von Dienstleistungen für Gründungsdarlehen und Kapitalumschlag",
  "creditWorry": "Kredit ohne Sorgen",
  "creditQuota": "Flexibles Limit",
  "creditQuotaINFO": "100.000 bis 30.000.000 mit flexiblem Limit und ohne Einschränkungen, mit einer maximalen Kreditlaufzeit von einem Jahr.",
  "quickLoan": "Schneller Kredit",
  "creditReview": "Bestehen Sie die Prüfung frühestens in einer Stunde, bei bestandener Prüfung wird der Kredit sofort freigegeben.",
  "safe": "Sicher und sorgenfrei",
  "safeInfo": "Keine Hypothek, keine Kaution, kein Rückruf, denn das ist eigentlich Privatsache.",
  "about": "Über uns",
  "aboutText1": "\"Wir engagieren uns für Kreditfinanzdienstleistungen, basierend auf der Geschäftsphilosophie \"\"Kunde zuerst\"\", und haben die Mission, das Problem des Kundenkapitalumsatzes zu lösen. Seit seiner Gründung hat das Unternehmen zahlreichen Kunden geholfen, das Problem des Kapitalumschlags zu lösen.\"",
  "aboutText2": "Limit: 100.000–30.000.000, flexible Rückzahlungsmethode mit niedrigen Zinsen, keine Vorabgebühr, Online-Darlehen, kein Telefonanruf zur Überprüfung, vertrauliche Informationen und Ausleihe am selben Tag.",
  "contactUs1": "Wenn Sie kein Geld von Ihren Levelkollegen leihen möchten, kontaktieren Sie uns bitte.",
  "committed": "Engagiert für Unternehmerdarlehensdienste",
  "financial": "Sprechen Sie Ihre finanziellen Bedenken an",
  "partnersTit": "Partner-Online-Ausleihplattform",
  "application": "Kreditantrag",
  "applicant": "Antragsteller",
  "actualName": "Echter Name",
  "yourName": "Bitte geben Sie den Namen ein",
  "term": "Laufzeit des Darlehens",
  "applicationAmount": "Angeforderter Betrag",
  "rates": "Darlehenszinssatz",
  "loanMethod": "Art der Ausleihe",
  "accountB": "Kontostand",
  "countryOf": "Staatsangehörigkeit",
  "myloan": "Mein Darlehen",
  "applyLoan": "Ein Darlehen beantragen",
  "loaned": "Ausgeliehen",
  "interest": "Aufgelaufene Zinsen",
  "esRepayment": "Geschätzte Rückzahlung",
  "loanHistory": "Kreditaufnahme",
  "applicantDate": "Antragsdatum",
  "repayment": "Rückzahlung",
  "cycle": "Rückzahlungszyklus",
  "fixedRate": "Fester Zinssatz",
  "successLoan": "Darlehen erfolgreich",
  "Reapply": "Bewerben Sie sich erneut",
  "borrow": "Kredit fehlgeschlagen",
  "applicantIn": "Bewerbung läuft",
  "repaid": "Rückzahlung",
  "overdue": "Überfällig",
  "estirepay": "Geschätzte Rückzahlung",
  "loanDays": "Anzahl der ausgeliehenen Tage",
  "reAmount": "Rückzahlungsbetrag",
  "repay": "Rückzahlungsmodus",
  "entRepay": "Rückzahlung bestätigen",
  "foryourmoney": "Wenn Sie knapp bei Kasse sind, nirgendwo Geld leihen können oder sich schämen, Geld von Ihren Freunden zu leihen, können Sie uns kontaktieren. Wir haben den gesamten Prozess des professionellen Service, um Ihre Zweifel jederzeit zu beantworten. Unser Ziel ist es, jeden Kredit transparent zu machen, damit Kunden ihn schnell und sicher nutzen können.",
  "onlineApplin": "Online bewerben",
  "businessloan": "Antrag auf Existenzgründungsdarlehen",
  "selectCountry": "Bitte wählen Sie eine Nationalität aus",
  "selectPeriod": "Bitte wählen Sie einen Zeitraum aus",
  "passPortImg": "ID-Nr./Pass-Nr.",
  "uploadId": "Foto-/Pass-Upload des Zertifikats",
  "readAndAgree": "Ich habe gelesen und stimme zu",
  "loanAgree": "Kreditvereinbarung",
  "submitApplica": "Antragstellung",
  "photoExample": "Beispiel zum Fotografieren",
  "discounted": "Reduzierte Produkte",
  "days": "Tag",
  "privacyPolicy": "Datenschutz-Bestimmungen",
  "delivery": "Lieferung und Abholung",
  "checkAgreement": "Bitte Zustimmung ankreuzen!",
  "businessPhone": "Geschäftstelefon",
  "businessEmail": "Firmen-E-Mail",
  recommendclass:"Kategorie empfehlen",
  "滑动验证":"Rollen Sie zur Bestätigung",
  "最多上传9张图片":"Hochladen von bis zu 9 Bildern",
  "账号注销":"Konto abmelden",
  "确定注销":"Abmelden bestätigen",
  "您的账号":"Ihr Konto",
  "为什么要离开":"Warum verlassen Sie uns?",
  "您还有余额,不能注销账号":"Sie haben noch einen Restbetrag, können Ihr Konto nicht abmelden!",
  "请输入注销理由":"Bitte geben Sie den Grund für die Abmeldung ein",
  "您确认要注销吗?":"Möchten Sie sich wirklich abmelden?",
  "我再考虑下": "Ich überlege noch einmal",
  "同意注销": "Zustimmen zur Abmeldung",
  "cancelInfo":"warnen! Bitte seien Sie vorsichtig, wenn Sie das Konto kündigen. Wenn Sie das Konto nicht mehr verwenden, können Sie auf [Der Kündigung zustimmen] klicken. Möglicherweise können Sie sich nicht innerhalb weniger Tage nach der Kündigung registrieren.",
  "注销成功":"Abmeldung erfolgreich",
  "App下载(买家端)": "App-Download (Käuferseite)",
  "App下载(卖家端)": "App-Download (Verkäuferseite)",
  "暂无店铺":"Kein Geschäft",
  "请选择":"Bitte wählen",
  "提款地址绑定":"Auszahlungsadresse binden",
  "绑定成功":"Bindung erfolgreich",
  "仅能绑定一个收款地址!":"Nur eine Empfangsadresse binden!",
  "最多包含10位小数":"Maximal 10 Dezimalstellen",
  "加密货币":"Kryptowährung",
  "银行卡":"Bankkarte",
  "企业电话":"Geschäftstelefon",
  "职业机会":"Berufschancen",
  '参数缺失': 'Fehlende Parameter',
  '充值数量必填': 'Aufladebetrag erforderlich',
  "充值币种":"Währung aufladen",
  "充值金额":"Aufladebetrag",
  "充值金额不得小于":"Aufladebetrag darf nicht kleiner sein als",
  "充值金额不得大于":"Aufladebetrag darf nicht größer sein als",
  "请先选择币种": "Bitte wählen Sie zuerst die Währung aus",
  "开户行":"Bank",
  "请输入开户行名称":"Bitte geben Sie den Namen der Bank ein",
  "银行卡号":"Kartennummer",
  "客户端下载": "Client-Download",
  "请输入银行卡号":"Bitte geben Sie die Kartennummer ein",
  "点击去支付":"Klicken Sie auf [Zur Zahlung]",
  "企业证明":"Unternehmensnachweis",
  当前余额:"Aktueller Kontostand",
  "提现方式":"Auszahlungsart",
  "备注":"Bemerkung",
  footTipTikTok:'CoveBuy Mall ©️2024 Urheberrecht',
  TikTokFoot:"CoveBuy Mall ist eine globale soziale Kurzvideoplattform, die CoveBuy und Asiens größtes Großhandelsunternehmen Alibaba in Zusammenarbeit gegründet haben. Es handelt sich um eine globale E-Commerce-Plattform und verfügt weltweit über drei selbst betriebene Smart Warehouses in Toronto (Kanada), Los Angeles und Chiba (Japan). Zu den in der App angebotenen Produkten gehören beliebte Produkte aus Japan, Südkorea, China und anderen asiatischen Ländern. Derzeit liegt die Gesamtzahl bei über 50.000 und wächst weiterhin rasant.",
  "betaBannerText": "Die Website befindet sich im öffentlichen Test. Bitte geben Sie keine Bestellungen auf."
}